import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";

const SportsJobAvailableNow = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const [isAvailable, setIsAvailable] = useState({});

  const [originalProfileData, setOriginalProfileData] = useState({});
  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState('');
  const [creatingProfile, setCreatingProfile] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    try {
      const config = {
        url: "/blueprofile/availablebyid",
        method: 'post',
        data: { userId: userId },
        headers: { Authorization: authState.token },
      };
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("profile exists ",response);
            setProfileExists(true);
            setIsAvailable(isAvailable);
          } else {
            setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
          }
        })
        .catch(() => {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        });
    } catch {
      setCreateSuccessMsg("Sorry! Profile not found. Please retry.");
    }
  }, [userId, fetchData, setProfileExists]);

  const handleAvailabilityUpdate = useCallback(() => {
    const config = {
      url: `/blueprofile/updateavailability`,
      method: 'post',
      data: { isAvailable: isAvailable, userId: userId},
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setUpdateSuccess(true);
          setUpdateSuccessMsg("Availability Updated successfully!");
        } else {
          setUpdateSuccessMsg("Error updating! Please retry.");
        }
      })
      .catch(() => {
        setUpdateSuccessMsg("Error updating! Please retry.");
      });
  }, [isAvailable, profileId, fetchData]);

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <MainLayout>
      <div className="text-lg mt-12 mb-4 mx-8">
        <h2 className="text-2xl font-bold text-white text-center mb-6">Blue Profile</h2>
      </div>
  
      <div className="min-h-[50vh] mt-4 border border-b-gray-300 p-6 rounded-lg bg-gray-800 text-white">
        {!profileExists ? (
          <div className="flex justify-center items-center mt-4">
            <button
              className="create-profile-button px-4 py-2 bg-blue-600 rounded-full text-white hover:bg-blue-700"
              onClick={handleCancel}
            >
              Your Blue Profile Does Not Exist!!
            </button>
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col">
                <label className="text-yellow-200">Name:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={authState.user.name}
                  disabled
                />
              </div>
            </div>
  
            <div className="flex mt-6 gap-4">
              <button
                className="update-profile-button px-4 py-2 bg-green-600 rounded-full text-white hover:bg-green-700 w-40"
                onClick={handleAvailabilityUpdate}
              >
                {isAvailable ? "Make Unavailable" : "Make Available"}
              </button>
              <button
                className="update-profile-button px-4 py-2 bg-red-600 rounded-full text-white hover:bg-red-700 w-40"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </>
        )}
      </div>
    </MainLayout>
  );
};

export default SportsJobAvailableNow;



